import { createBrowserRouter } from "react-router-dom";
import { Suspense, lazy } from "react";
import PrivateRoute from "../PrivateRoute";
import Animations from "../../components/animation/Animation";
import App from "../../App";
import PrivateRouteModule from "../PrivateRouteModule";

const BalcaoVendas = lazy(() => import('../../pages/balcao/balcaoVendas/BalcaoVendas'));
const Home = lazy(() => import('../../pages/balcao/home/Home'));
const ConsultarCliente = lazy(() => import('../../pages/cliente/consultarCliente/ConsultarCliente'));
const ConsultarMaterial = lazy(() => import('../../pages/balcao/consultarMaterial/ConsultarMaterial'));
const ConsultarMovimeto = lazy(() => import('../../pages/balcao/consultarMovimento/ConsultarMovimento'));
const ItensMaisComprados = lazy(() => import('../../pages/balcao/listarMovimento/ItensMaisComprados'));
const CadastrarCliente = lazy(() => import('../../pages/cliente/cadastrarCliente/CadastrarCliente'));
const ConsultarRotas = lazy(() => import('../../pages/balcao/consultarRotas/ConsultarRotas'));
const CentroDeCusto = lazy(() => import('../../pages/balcao/centroDeCusto/CentroDeCusto'));
const Permissoes = lazy(() => import('../../pages/balcao/balcaoVendas/Permissoes'));

const rotasBalcao = createBrowserRouter([
    {
        id: 'app-balcao',
        path: '/balcaovendas',
        element: <App />,
        children: [
            {
                id: 'balcao',
                path: '',
                element: (
                    <Suspense>
                        <PrivateRoute>
                            <PrivateRouteModule>
                                <BalcaoVendas />
                            </PrivateRouteModule>
                        </PrivateRoute>
                    </Suspense>
                ),
                children: [
                    {
                        path: '',
                        element: (
                            <Suspense fallback={<Animations />}>
                                <PrivateRoute>
                                    <Home />
                                </PrivateRoute>
                            </Suspense>
                        )
                    },
                    {
                        path: 'itens-mais-comprados',
                        element: (
                            <Suspense fallback={<Animations />}>
                                <PrivateRoute>
                                    <ItensMaisComprados />
                                </PrivateRoute>
                            </Suspense>
                        )
                    },
                    {
                        path: 'consultar-clientes',
                        element: (
                            <Suspense fallback={<Animations />}>
                                <PrivateRoute>
                                    <ConsultarCliente />
                                </PrivateRoute>
                            </Suspense>
                        )
                    },
                    {
                        path: 'cadastrar-cliente',
                        element: (
                            <Suspense fallback={<Animations />}>
                                <PrivateRoute>
                                    <CadastrarCliente />
                                </PrivateRoute>
                            </Suspense>
                        )
                    },
                    {
                        path: 'consultar-materiais',
                        element: (
                            <Suspense fallback={<Animations />}>
                                <PrivateRoute>
                                    <ConsultarMaterial />
                                </PrivateRoute>
                            </Suspense>
                        )
                    },
                    {
                        path: 'consultar-movimentos',
                        element: (
                            <Suspense fallback={<Animations />}>
                                <PrivateRoute>
                                    <ConsultarMovimeto />
                                </PrivateRoute>
                            </Suspense>
                        )
                    },
                    {
                        path: 'consultar-rotas',
                        element: (
                            <Suspense fallback={<Animations />}>
                                <PrivateRoute>
                                    <ConsultarRotas />
                                </PrivateRoute>
                            </Suspense>
                        )
                    },
                    {
                        path: 'centro-de-custo',
                        element: (
                            <Suspense fallback={<Animations />}>
                                <PrivateRoute>
                                    <CentroDeCusto />
                                </PrivateRoute>
                            </Suspense>
                        )
                    },
                    {
                        path: 'permissoes',
                        element: (
                            <Suspense fallback={<Animations />}>
                                <PrivateRoute><Permissoes /></PrivateRoute>
                            </Suspense>
                        )
                    },
                ]
            },
        ]
    },
]);

export default rotasBalcao;
